import { Badge } from '../../components/ui';

export const statusPedidoLojaMap: Record<string, { tom: string; label: string }> = {
  AGUARDANDO_PAGAMENTO: { tom: 'amber', label: 'Aguardando pagamento' },
  PAGO: { tom: 'blue', label: 'Pago' },
  EM_PRODUCAO: { tom: 'blue', label: 'Em produção' },
  PRONTO: { tom: 'green', label: 'Pronto' },
  ENTREGUE: { tom: 'gray', label: 'Entregue' },
  CANCELADO: { tom: 'red', label: 'Cancelado' },
};

export const pagamentoLojaMap: Record<string, { tom: string; label: string }> = {
  PENDENTE: { tom: 'amber', label: 'Pagamento pendente' },
  APROVADO: { tom: 'green', label: 'Pagamento aprovado' },
  RECUSADO: { tom: 'red', label: 'Pagamento recusado' },
  ESTORNADO: { tom: 'gray', label: 'Pagamento estornado' },
};

export function BadgeStatusLoja({ status }: { status: string }) {
  const s = statusPedidoLojaMap[status] || { tom: 'gray', label: status };
  return <Badge tom={s.tom} label={s.label} />;
}

export function BadgePagamentoLoja({ status }: { status: string }) {
  const s = pagamentoLojaMap[status] || { tom: 'gray', label: status };
  return <Badge tom={s.tom} label={s.label} />;
}

/** Pedido pode ser pago online (ainda não aprovado e não cancelado). */
export function podePagarOnline(pedido: { status: string; pagamentoStatus: string }): boolean {
  return pedido.pagamentoStatus !== 'APROVADO' && pedido.status !== 'CANCELADO';
}

/** Etapas de progresso do pedido (para a linha do tempo do cliente). */
export const etapasPedido = ['AGUARDANDO_PAGAMENTO', 'PAGO', 'EM_PRODUCAO', 'PRONTO', 'ENTREGUE'];

export function indiceEtapa(status: string): number {
  const i = etapasPedido.indexOf(status);
  return i === -1 ? 0 : i;
}
